// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import { type APIPromise, APIResource, type FetchParams } from "../../core";

import type { ErrorBody, Receipt } from "../../types";
export type GetReceiptQueryParams = {
  mid: string;
  tx_event_id?: number;
};

export class Receipts extends APIResource {
  /**
   * Retrieves receipt specific data for a transaction.
   */
  get(
    id: string,
    query: GetReceiptQueryParams,
    params?: FetchParams,
  ): APIPromise<Receipt, ErrorBody> {
    return this._client.get<Receipt, ErrorBody>({
      path: `/v1.1/receipts/${id}`,
      query,
      ...params,
    });
  }
}
